import { render, staticRenderFns } from "./AppPrompt.vue?vue&type=template&id=7c19e644&scoped=true&"
import script from "./AppPrompt.vue?vue&type=script&lang=ts&"
export * from "./AppPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./AppPrompt.vue?vue&type=style&index=0&id=7c19e644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19e644",
  null
  
)

export default component.exports